const MAP = {
  connected: "bg-emerald-50 text-emerald-700 border-emerald-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  success: "bg-emerald-50 text-emerald-700 border-emerald-200",
  running: "bg-indigo-50 text-[#312E81] border-indigo-100",
  queued: "bg-amber-50 text-amber-700 border-amber-200",
  paused: "bg-amber-50 text-amber-700 border-amber-200",
  configured: "bg-stone-100 text-stone-600 border-stone-200",
  draft: "bg-stone-100 text-stone-600 border-stone-200",
  validated: "bg-indigo-50 text-[#312E81] border-indigo-100",
  disabled: "bg-stone-100 text-stone-400 border-stone-200",
  failed: "bg-rose-50 text-rose-700 border-rose-200",
  error: "bg-rose-50 text-rose-700 border-rose-200",
};

export function StatusBadge({ status }) {
  const cls = MAP[status] || "bg-stone-100 text-stone-600 border-stone-200";
  return (
    <span data-testid={`status-${status}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full border text-xs font-medium capitalize ${cls}`}>
      {status}
    </span>
  );
}
